import React from 'react';
import './FormFieldDescription.scss';

const FormFieldDescription = ({children}) => {
  return <div className='field--description'>{children}</div>;
};

export default FormFieldDescription;
